import React, { useContext } from 'react'
import { navigate } from 'gatsby-plugin-intl'

import PlayIcon from '@icons/Play'
import PauseIcon from '@icons/Pause'
import JumpLink from '@molecules/JumpLink'
import { useTranslation } from '@models/Translation'
import { StoreContext } from '@models/Store'
import { checkMaxAudioCount } from '@models/Voice'

import * as style from './style.module.sass'

export type SectionHeadlineProps = {
  subLine: string
  head: string
  buttonTitle?: string
  navigateTo?: string
  design?: 'light' | 'dark'
  isArtisan?: boolean
}

const SectionHeadline: React.FC<
  SectionHeadlineProps & {
    children?: React.ReactNode
  }
> = ({
  subLine,
  head,
  buttonTitle,
  navigateTo,
  design = 'light',
  isArtisan,
  children,
}) => {
  const { t, locale } = useTranslation()
  const { action, entity } = useContext(StoreContext)
  const enablesButton =
    typeof navigateTo === 'string' &&
    navigateTo.length > 0 &&
    typeof buttonTitle === 'string' &&
    buttonTitle.length > 0
  const isPlaying = entity.voice.isPlaying && entity.voice.context === 'latest'

  const playAll = () => {
    if (entity.user?.isSignIn !== true) {
      if (checkMaxAudioCount()) {
        navigate('/signup?limit=voice')
        return
      }
    }

    if (entity.voice.context === 'latest') {
      action.setVoiceIsPlaying(true)
      return
    }

    action.setVoiceArticleIds([], 'latest')
  }

  return (
    <>
      <div className={style.sectionHeadline} data-design={design}>
        <div className={style.container}>
          {locale === 'ja' && <h2 className={style.subLine}>{subLine}</h2>}
          <p className={style.head} data-artisan={isArtisan}>
            {head}
            {navigateTo === '/all' && (
              <>
                {isPlaying ? (
                  <button
                    onClick={() => action.setVoiceIsPlaying(false)}
                    className={style.play}
                    data-show={entity.user !== undefined}
                    data-playing={true}
                  >
                    <PauseIcon />
                    {t('voice.stop')}
                  </button>
                ) : (
                  <button
                    onClick={playAll}
                    className={style.play}
                    data-show={entity.user !== undefined}
                  >
                    <PlayIcon />
                    {t('voice.playAll')}
                  </button>
                )}
              </>
            )}
          </p>
        </div>
        {enablesButton && (
          <div className={style.linkContainer}>
            <JumpLink to={navigateTo}>{buttonTitle}</JumpLink>
          </div>
        )}
      </div>
      {children}
      {enablesButton && (
        <div className={style.spLinkContainer}>
          <JumpLink to={navigateTo}>{buttonTitle}</JumpLink>
        </div>
      )}
    </>
  )
}

export default SectionHeadline
